import React from 'react';
import { Routes } from 'react-router-dom';

import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import ChallengeConfigurePage from './ChallengeConfigurePage';
import ChallengeCreatePage from './ChallengeCreatePage';
import ChallengeUpdatePage from './ChallengeUpdatePage';

const Challenge: React.FC = () => (
  <Routes>
    <Route
      path='create'
      element={
        <ProtectedRoute feature={Feature.CAMPAIGN_COMPONENT_CREATE}>
          <ChallengeCreatePage />
        </ProtectedRoute>
      }
    />
    <Route path=':challengeId/configure/*' element={<ChallengeConfigurePage />} />
    <Route path=':challengeId/update/*' element={<ChallengeUpdatePage />} />
  </Routes>
);

export default Challenge;
